export default __webpack_public_path__ + "static/media/refresh.b378798b.svg";